import React from 'react';

export const loadTawkTo = (siteKey, context, onloadFunction) => {
  let tawkSrc;
  const siteWithTawk = ['at', 'ch', 'dk', 'global', 'de'];
  const pathname = window.location.pathname;

  switch (siteKey) {
    case 'at':
      tawkSrc = 'https://embed.tawk.to/69fb6f894960f31c3616e37e/1jnv2nclj';
      break;
    case 'ch':
      tawkSrc = 'https://embed.tawk.to/6a180d374298741c3c11618f/1jpmv78mr';
      break;
    case 'dk':
      tawkSrc = 'https://embed.tawk.to/5fff0cb0a9a34e36b96c09a9/1eru4j4l0';
      break;
    case 'de':
      tawkSrc = 'https://embed.tawk.to/62ecd96b54f06e12d88d0eb2/1g9mj2jr9';
      break;
    default:
      tawkSrc = 'https://embed.tawk.to/5fff0c26a9a34e36b96c096e/1eru4etqf';
  };


  // 2. Ініціалізація window.Tawk_API та onLoad колбеку до setTimeout
  if (siteWithTawk.includes(siteKey)) {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    window.Tawk_API.onLoad = function() {
      // Виклик setAttributes з даними користувача та контекстом сторінки
      window.Tawk_API.setAttributes({
        path: pathname,
        ...context
      }, function(error) {
        if (error) console.error('Tawk.to setAttributes error:', error);
      });

      // Додавання кастомної події сторінки
      window.Tawk_API.addEvent('page-context', {
        page: context.page || 'other',
        path: pathname
      }, function(error) {
        if (error) console.error('Tawk.to addEvent error:', error);
      });

      if (onloadFunction) onloadFunction();
    };

    setTimeout(function () {
      (function () {
        const s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = tawkSrc;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      })();
    }, 10000);
  }
};
